import { IOptionState, IOptionsState } from "../store/selectableOptions/types";

export const transformOptions = (options: IOptionsState[]) => {
    const sortedOptions = options.sort((a, b) => {
        if (a.isOther) {
            return 1;
        }
        if (b.isOther) {
            return -1;
        }
        return 0;
    });
    return sortedOptions.reduce((accOption, option) => {
        return {
            ...accOption,
            [String(option._id)]: completeOptionData(option),
        };
    }, {});
};

function completeOptionData(option: any) {
    const initialOption: IOptionState = {
        label: "",
        disabled: false,
        value: {
            price: { value: "" },
            quantity: { value: 0 },
            allowSelectQuantity: false,
            custom: [{ title: "month", value: "", enabled: false }],
        },
    };
    return { ...initialOption, ...option };
}
